import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetHeartFill: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        stroke="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 21C6 17 2 13 2 9a5 5 0 0110-1 5 5 0 0110 1c0 4-4 8-10 12z" />
      </svg>
    </div>
  );
};

export default WidgetHeartFill;
